export const HTTP_METHOD_POST = 'POST';
export const HTTP_METHOD_GET = 'GET';

export const PREFIX = 'aaf_app_';
// const for detail Selector
export const DETAIl_S = `${PREFIX}detail_selector`;
// Register class names
export const DETAILTRANSACTION = `${PREFIX}transaction_detail`;

// Payment method select
export const PAYMENT_METHOD_SELECT = `${PREFIX}payment-method-select`;

//Telmex method
export const PAYMENT_TELMEX = `${PREFIX}payment-telmex`;

//Telcel method
export const PAYMENT_TELCEL = `${PREFIX}payment-telcel`;

//Card method
export const PAYMENT_CARD = `${PREFIX}payment-card`;

//Code method
export const PAYMENT_CODE = `${PREFIX}payment-code`;

//Factura fija
export const PAYMENT_FACTURA_FIJA = `${PREFIX}payment-factura-fija`;

//Hub fija
export const PAYMENT_HUB_FIJA = `${PREFIX}payment-hub-fija`;

//HubBidirectional
export const PAYMENT_HUB_BIDIRECTIONAL = `${PREFIX}payment-hubbidirectional`;

//Colombia Gate
export const PAYMENT_COLOMBIA_GATE = `${PREFIX}payment-colombia-gate`;

//CVV
export const PAYMENT_CVV = `${PREFIX}payment-cvv`;

//Change payment method
export const CHANGE_PAYMENT_METHOD = `${PREFIX}change-payment-method`;

// Border color general in input outfocus
export const PAYMENT_INPUT_STYLE_OUTFOCUS = '3px solid #4C6F94';

//Llaves Screen QR
export const ENABLE_QR_SCREEN =  '{"default": {"enabled": false}}';
export const QR_SCREEN = '{"default": {"config": {"addmdp": {"url": "https://www.clarovideo.com/agregarmdp", "tag": "agregarmdp", "inactivity_timeout_seconds": 300}, "editmdp": {"url": "https://www.clarovideo.com/editarmdp", "tag": "editmdp", "inactivity_timeout_seconds": 300}}, "pulling_duration_seconds": 5, "qr_retries": 5, "payment_methods_order": ["telmexmexicogate", "hubgate", "claropagosgate"]}}';

export const DELETE = 'DELETE';
export const GET = 'GET';
export const SUCCESFULL = 'successful';
export const EXPIRED = 'expired';

/*
Getways constants FORM API
*/
export const GETWAY_CLAROCOLOMBIA = 'clarocolombiagate';
export const GETWAY_HUB = 'hubgate';
export const GETWAY_TELMEX = 'telmexmexicogate';
export const GETWAY_HUBFIJO = 'hubfijogate';
export const GETWAY_HUBFACTURAFIJA = 'hubfacturafijagate';
export const GETWAY_PROMO = 'promogate';
export const GETWAY_CREDITCARD = 'plazavipgate';
export const GETWAY_AMCO = 'amcogate';
export const GETWAY_CLAROPAGO = 'claropagosgate';
export const GETWAY_HUBCORPORATIVOFIJO = 'hubcorporativofijogate';
export const GETWAY_HUBCORPORATIVOFIJOFORM = 'hubcorporativofijogateForm';
export const GETWAY_HUBBIDERECTIONAL = 'hubbidirectional';

/*Metrics*/
export const VCARD_CONTRATA = 'contrata';
export const VCARD_COMPONENT = 'vcard';

/* Components */
export const TRANSACTION_COMPONENT_PLAN_SELECTOR = 'plan-selector';
export const TRANSACTION_COMPONENT_CHECKOUT = 'checkout';
export const TRANSACTION_COMPONENT_TICKET = 'ticket';
export const TRANSACTION_COMPONENT_LANDING = 'comercial-landing';
export const TRANSACTION_COMPONENT_UPSELL = 'upsell';
export const TRANSACTION_COMPONENT_VCARD = 'vCard';
export const PROMOGATE = 'promogate'
export const PAYPALGATE = 'paypalgate'

export const MONTHS = [
    "ene", "feb", "mar", "abr", "may", "jun",
    "jul", "ago", "sep", "oct", "nov", "dic"
];

//Laves para mostrar las modales de agregar y editar metodo de pago
export const ADDEDITPAYMENTMETHODINFOCONFIG = 'add_edit_payment_method_info_config';
export const DEFAULTADDEDITPAYMENTMETHODINFOCONFIG = '{"default": { "enable": false}}';



// WEBPACK FOOTER //
// ./src/payments/utils/constants.ts